import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface CreateAnnouncementInput {
    message: string;
    /** How many days the banner should run before it auto-expires. */
    durationDays?: number;
}

const createAnnouncement = async (data: CreateAnnouncementInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/announcements`, data, {
        headers: { Authorization: sessionId },
    });
};

export const useCreateAnnouncement = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateAnnouncementInput) =>
            createAnnouncement(data, sessionContext?.sessionId ?? null),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['/notifications'] });
        },
    });
};
